const homepage = {
  aboutIade: {
    title: {
      1: 'Ihreapotheken.de - the online shop of your favorite local pharmacy',
      2: 'Order online easily - receive your order on the same day',
      3: 'Expert advice - well-informed',
      4: 'Now available as an app!',
    },
    paragraph: {
      1: 'Ihreapotheken.de is the first nationwide online shop for local pharmacies. You can now easily order medicines or beauty and care products online from your local favorite pharmacy. In addition to traditional medications for headaches, homeopathic or herbal remedies, Ihreapotheken.de offers you a large range of well-known brands such as Vichy, Eucerin, Roche Posay, Claudalie, or CeraVe.',
      2: 'With just a few clicks, you can order from your local pharmacy through Ihreapotheken.de. You can also easily and securely redeem prescriptions for prescription medications. Your order will be ready for pickup within a few hours – or you can opt for the delivery service and have the medications brought to your home.',
      3: 'Do you have questions? The experienced and competent staff at your favorite local pharmacy are happy to assist you. Valuable medical information and enjoyable reading are also provided by the pharmacy magazine my life. You can receive the magazine for free at your pharmacy or as an addition to your order.',
      4: 'Ihreapotheken.de is now also available as an app - download now.',
    },
    button: 'Choose Pharmacy',
    urlText: {
      1: 'Redeem Prescription',
      2: 'Order Medicines',
      3: 'Discover my life',
    },
  },
}

export default homepage
